import {toast} from 'sonner';
import {getApiErrorMessage} from '~/lib/errors/apiError';

export const notify = {
    success: (message: string) => toast.success(message),
    info: (message: string) => toast.info(message),
    warning: (message: string) => toast.warning(message),
    error: (message: string) => toast.error(message),
    apiError: (error: unknown, fallback = 'Request failed') =>
        toast.error(getApiErrorMessage(error, fallback), {style: {whiteSpace: 'pre-line'}})
};
